<h1 mat-dialog-title>Update Task</h1>

<div mat-dialog-content>
  <form [formGroup]="taskForm">
    <br>
    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input formControlName="title" matInput placeholder="Title">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <textarea formControlName="description" matInput placeholder="Description"></textarea>
    </mat-form-field>


    <mat-form-field>
      <mat-label>Choose expiration date</mat-label>
      <input formControlName="date" matInput [matDatepicker]="picker">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

  </form>

  <div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" mat-dialog-close>Close</button>
    <button mat-raised-button color="primary" (click)="updateTask()" >Update</button>
  </div>
</div>
